// extracted by mini-css-extract-plugin
module.exports = {"container":"_2yjKN4","loading":"_3yAWKd","video":"_1Pp--T"};